"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Reduces values
 */
function reduce(reducer, init) {
    return async function inner(source) {
        let accumulator = await init;
        for await (const next of source) {
            accumulator = await reducer(accumulator, next);
        }
        return accumulator;
    };
}
exports.reduce = reduce;
